import { render, staticRenderFns } from "./VisitLinkSmall.vue?vue&type=template&id=388bb807&scoped=true"
import script from "./VisitLinkSmall.vue?vue&type=script&lang=js"
export * from "./VisitLinkSmall.vue?vue&type=script&lang=js"
import style0 from "./VisitLinkSmall.vue?vue&type=style&index=0&id=388bb807&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388bb807",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('388bb807')) {
      api.createRecord('388bb807', component.options)
    } else {
      api.reload('388bb807', component.options)
    }
    module.hot.accept("./VisitLinkSmall.vue?vue&type=template&id=388bb807&scoped=true", function () {
      api.rerender('388bb807', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/VisitLink/VisitLinkSmall.vue"
export default component.exports